module.exports = __webpack_public_path__ + "img/trinapp-files-yellow.af137205.png";